export class CrdtAlgorithmReferenceToObject {
    algoType = 'ReferenceToObject';
}
export function isReferenceToObjectCrdtAlgorithm(algo) {
    return algo.algoType === 'ReferenceToObject';
}
//# sourceMappingURL=CrdtAlgorithmReferenceToObject.js.map